import React, { FC } from 'react';
import { ErrorBoundary as SentryErrorBoundary } from '@sentry/react';

import { ErrorBoundaryPage } from './ErrorBoundaryPage';

// React 18 has removed children from FC (which, IMHO, was the only reason to use it)
// They also suggest try not to use FC, and declare children separately

export const ErrorBoundary: FC = ({ children }) => (
  <SentryErrorBoundary fallback={({ resetError }) => <ErrorBoundaryPage resetError={resetError} />}>
    {children}
  </SentryErrorBoundary>
);
